import React from 'react';
import UnderConstruction from '../../components/molecules/UnderConstruction.jsx';

function BulkEmail() {
  return (
    <UnderConstruction title="Bulk Email" />
  );
}

export default BulkEmail;


